var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.68 32.5317L28.6899 15.8027C28.6899 14.3267 27.336 12.9727 25.6639 12.9727H25.496C23.823 12.9727 22.4699 14.3267 22.4699 15.9987V38.4257C21.5869 37.3487 16.6799 31.4427 14.476 33.1077C12.272 34.7727 13.6929 36.7807 13.6929 36.7807C15.712 40.4047 20.33 47.9787 21.576 50.1097C23.963 54.1897 28.289 56.9157 33.228 56.9157C40.747 56.9157 46.8419 50.5997 46.8419 42.8067V42.2957V30.3007C46.8419 28.7647 45.597 27.3237 44.062 27.3237H43.9069C42.3709 27.3237 41.1269 28.7637 41.1269 30.3007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6797 26.8239C28.6797 25.1519 30.0337 23.7969 31.7057 23.7969H31.8737C33.5457 23.7969 34.8997 25.1519 34.8997 26.8239V32.5329",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9023 28.7279C34.9023 27.0559 36.2573 25.5039 37.9293 25.5039H38.0973C39.7693 25.5039 41.1243 27.0559 41.1243 28.7279V32.5299",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6604 18.9C18.1214 17.84 17.8184 16.642 17.8184 15.374C17.8184 11.07 21.3064 7.58203 25.6104 7.58203C29.9144 7.58203 33.4024 11.07 33.4024 15.374C33.4024 16.801 33.0194 18.138 32.3494 19.288",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5052 21.169C13.6442 19.476 13.1602 17.561 13.1602 15.533C13.1602 8.65603 18.7342 3.08203 25.6112 3.08203C32.4882 3.08203 38.0622 8.65603 38.0622 15.533C38.0622 17.813 37.4512 19.95 36.3792 21.788",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.f320ac96ee4cc5f3365dd6c87a08a44c.svg";
export { ForwardRef as ReactComponent };